  <div style="text-align: center;">
    <div *ngIf="!readOnly; else imgCheckbox"
          style="cursor: pointer; vertical-align: middle;"
          class="ui checkbox"
         (click)="onClick()">
      <input type="checkbox" [checked]="cbValue">
      <div class="box"></div>
    </div>
    <ng-template #imgCheckbox>
      <i *ngIf="cbValue" class="ui check icon"></i>
    </ng-template>
  </div>
